import { uploadBlogImage } from "../api/blogs";
import { isUploadedBlogImagePath } from "./blogImages";

/**
 * Uploads each in-editor image placeholder and replaces it with a stored `/uploads/blog-images/` img.
 * Mutates `filesById` (Map): deletes entries for uploaded ids.
 * @param {string} html
 * @param {Map<string, File>} filesById
 * @returns {Promise<string>}
 */
export async function flushPendingImagesInHtml(html, filesById) {
    const raw = typeof html === "string" ? html : "";
    if (!raw.includes("oa-image-pending") && !raw.includes("data-image-pending-id")) {
        return raw;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div class="oa-flush-root">${raw}</div>`, "text/html");
    const root = doc.querySelector(".oa-flush-root");
    if (!root) return raw;

    const nodes = [...root.querySelectorAll(".oa-image-pending[data-image-pending-id]")];
    for (const el of nodes) {
        const id = el.getAttribute("data-image-pending-id");
        if (!id) {
            el.remove();
            continue;
        }
        const file = filesById.get(id);
        if (!file) {
            const label = el.getAttribute("data-image-label") || id;
            throw new Error(
                `An image in the article is missing its file (“${label}”). Remove it or insert the image again, then save.`
            );
        }
        let imageUrl;
        try {
            ({ imageUrl } = await uploadBlogImage(file));
        } catch (err) {
            const label = el.getAttribute("data-image-label") || "image";
            throw new Error(
                err?.response?.data?.message ||
                err?.message ||
                `Failed to upload "${label}". Please try again.`
            );
        }
        if (!imageUrl || !isUploadedBlogImagePath(imageUrl)) {
            throw new Error("The server returned an invalid path after uploading an image. Please try again.");
        }
        const repl = doc.createElement("p");
        const img = doc.createElement("img");
        img.setAttribute("src", imageUrl);
        img.setAttribute("alt", el.getAttribute("data-image-label") || "");
        repl.appendChild(img);
        el.replaceWith(repl);
        filesById.delete(id);
    }

    return root.innerHTML;
}
